import ReactDOM from 'react-dom/client'

// import * as Sentry from '@sentry/react'

import App from './App'

// Sentry.init({
//   dsn: import.meta.env.VITE_SENTRY_DSN,
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   enableLogs: true,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//     Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: [
//     'localhost',
//     import.meta.env.VITE_REACT_APP_API_URL,
//   ],
//   environment: import.meta.env.VITE_REACT_APP_STAGE,
//   debug: true,
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
